import type {
  BankStatementPeriodEntry,
  BankStatementUpload,
} from '../../api/bank-statements.service';
import { route, type HandlerEntry } from '../handler-registry';

function emptyByPeriod(year: number): readonly BankStatementPeriodEntry[] {
  return Array.from({ length: 12 }, (_, i) => ({
    year,
    month: i + 1,
    period: `${year}-${String(i + 1).padStart(2, '0')}`,
    upload: null,
  }));
}

export const bankStatementsHandlers: readonly HandlerEntry[] = [
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/bank-statements\/by-period$/,
    (ctx) => {
      const year = Number(ctx.query.get('year')) || new Date().getFullYear();
      return emptyByPeriod(year);
    },
  ),
  route('GET', /^\/api\/tenants\/([^/]+)\/bank-statements$/, () => []),
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/bank-statements\/([^/]+)\/lines$/,
    () => ({ error: { status: 404, message: 'Not found in demo mode' } }),
  ),
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/bank-statements\/([^/]+)\/file$/,
    () => ({ error: { status: 404, message: 'Not found in demo mode' } }),
  ),
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/bank-statements\/([^/]+)$/,
    () => ({ error: { status: 404, message: 'Not found in demo mode' } }),
  ),
  route(
    'POST',
    /^\/api\/tenants\/([^/]+)\/bank-statements$/,
    (): BankStatementUpload => {
      const now = new Date();
      const period = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      return {
        id: 'demo-upload',
        uploadedAt: now.toISOString(),
        fileName: 'extras-demo.csv',
        byteSize: 0,
        hasOriginalFile: false,
        iban: 'RO00DEMO0000000000000000',
        currency: 'RON',
        statementStartDate: null,
        statementEndDate: null,
        period,
        periodYear: now.getFullYear(),
        periodMonth: now.getMonth() + 1,
        totalRows: 0,
        matchedCount: 0,
        unmatchedCount: 0,
        amountMismatchCount: 0,
        duplicateCount: 0,
        matches: [],
        unmatched: [],
      };
    },
  ),
];
